import React, { useState } from 'react';
import { User } from '../types';
import { PlusIcon, PencilIcon, KeyIcon, PowerIcon, SearchIcon, UsersIcon, ShieldCheckIcon, UserXIcon } from 'lucide-react';
import { SummaryCard } from '../components/SummaryCard';
interface UserManagementPageProps {
  users: User[];
}
export function UserManagementPage({
  users
}: UserManagementPageProps) {
  const [searchTerm, setSearchTerm] = useState('');
  const [roleFilter, setRoleFilter] = useState('Semua Role');
  const [statusFilter, setStatusFilter] = useState('Semua Status');
  const roles = ['Semua Role', ...Array.from(new Set(users.map(u => u.role)))];
  const filteredUsers = users.filter(user => {
    const matchSearch = user.name.toLowerCase().includes(searchTerm.toLowerCase()) || user.username.toLowerCase().includes(searchTerm.toLowerCase()) || user.email.toLowerCase().includes(searchTerm.toLowerCase());
    const matchRole = roleFilter === 'Semua Role' || user.role === roleFilter;
    const matchStatus = statusFilter === 'Semua Status' || statusFilter === 'Aktif' && user.isActive || statusFilter === 'Nonaktif' && !user.isActive;
    return matchSearch && matchRole && matchStatus;
  });
  const activeCount = users.filter(u => u.isActive).length;
  const inactiveCount = users.filter(u => !u.isActive).length;
  const adminCount = users.filter(u => u.role === 'Admin' || u.role === 'Koordinator').length;
  const handleAddUser = () => alert('Fitur tambah user akan tersedia pada versi berikutnya.');
  const handleEditUser = () => alert('Fitur edit user akan tersedia pada versi berikutnya.');
  const handleResetPassword = () => alert('Fitur reset password akan tersedia pada versi berikutnya.');
  const handleToggleActive = (name: string, isActive: boolean) => {
    const action = isActive ? 'menonaktifkan' : 'mengaktifkan';
    if (confirm(`Apakah Anda yakin ingin ${action} user ${name}?`)) {
      alert(`Status user ${name} berhasil diubah.`);
    }
  };
  return <div className="space-y-6 flex flex-col h-full" data-id="element-1035">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4" data-id="element-1036">
        <h2 className="text-2xl font-bold text-[#E2E8F0] uppercase tracking-wide flex items-center" data-id="element-1037">
          <UsersIcon className="w-6 h-6 mr-3 text-[#00D4FF]" data-id="element-1038" />
          MANAJEMEN USER
        </h2>
        <button onClick={handleAddUser} className="flex items-center px-4 py-2 bg-[#00D4FF] text-[#0B0F1A] rounded hover:bg-[#00D4FF]/90 transition-colors shadow-sm font-bold text-sm uppercase glow-cyan" data-id="element-1039">
          <PlusIcon className="w-4 h-4 mr-2" data-id="element-1040" />
          TAMBAH USER
        </button>
      </div>

      {/* Summary Cards */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1041">
        <SummaryCard title="Total User" value={users.length} icon={<UsersIcon className="w-6 h-6" data-id="element-1043" />} iconBgColor="bg-[#00D4FF]/10" iconColor="text-[#00D4FF]" borderColor="border-t-[#00D4FF]" data-id="element-1042" />
        <SummaryCard title="User Aktif" value={activeCount} icon={<ShieldCheckIcon className="w-6 h-6" data-id="element-1045" />} iconBgColor="bg-[#00FF88]/10" iconColor="text-[#00FF88]" borderColor="border-t-[#00FF88]" data-id="element-1044" />
        <SummaryCard title="User Nonaktif" value={inactiveCount} icon={<UserXIcon className="w-6 h-6" data-id="element-1047" />} iconBgColor="bg-[#FF3B3B]/10" iconColor="text-[#FF3B3B]" borderColor="border-t-[#FF3B3B]" data-id="element-1046" />
      </div>

      {/* Filters */}
      <div className="bg-[#111827] p-4 rounded shadow-sm border border-[#1E3A5F] flex flex-wrap gap-4 items-center" data-id="element-1048">
        <div className="relative flex-1 min-w-[250px]" data-id="element-1049">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-1050">
            <SearchIcon className="h-4 w-4 text-[#94A3B8]" data-id="element-1051" />
          </div>
          <input type="text" placeholder="Cari nama, username, atau email..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} className="block w-full pl-10 pr-3 py-2 border border-[#1E3A5F] rounded text-sm focus:ring-1 focus:ring-[#00D4FF] focus:border-[#00D4FF] bg-[#0B0F1A] text-[#E2E8F0] placeholder-[#475569]" data-id="element-1052" />
        </div>
        <select value={roleFilter} onChange={e => setRoleFilter(e.target.value)} className="border border-[#1E3A5F] rounded text-sm py-2 pl-3 pr-8 focus:ring-1 focus:ring-[#00D4FF] focus:border-[#00D4FF] bg-[#0B0F1A] text-[#E2E8F0]" data-id="element-1053">
          {roles.map(r => <option key={r} value={r} data-id="element-1054">
              {r}
            </option>)}
        </select>
        <select value={statusFilter} onChange={e => setStatusFilter(e.target.value)} className="border border-[#1E3A5F] rounded text-sm py-2 pl-3 pr-8 focus:ring-1 focus:ring-[#00D4FF] focus:border-[#00D4FF] bg-[#0B0F1A] text-[#E2E8F0]" data-id="element-1055">
          <option value="Semua Status" data-id="element-1056">Semua Status</option>
          <option value="Aktif" data-id="element-1057">Aktif</option>
          <option value="Nonaktif" data-id="element-1058">Nonaktif</option>
        </select>
      </div>

      <div className="bg-[#111827] rounded shadow-lg border border-[#1E3A5F] overflow-hidden flex-1" data-id="element-1059">
        <div className="overflow-x-auto" data-id="element-1060">
          <table className="w-full text-sm text-left" data-id="element-1061">
            <thead className="text-xs text-[#94A3B8] uppercase bg-[#0F1629] border-b border-[#1E3A5F]" data-id="element-1062">
              <tr data-id="element-1063">
                <th className="px-4 py-3 font-semibold w-12 text-center" data-id="element-1064">ID</th>
                <th className="px-4 py-3 font-semibold" data-id="element-1065">IDENTITAS</th>
                <th className="px-4 py-3 font-semibold" data-id="element-1066">USERNAME</th>
                <th className="px-4 py-3 font-semibold" data-id="element-1067">UNIT</th>
                <th className="px-4 py-3 font-semibold" data-id="element-1068">ROLE</th>
                <th className="px-4 py-3 font-semibold text-center" data-id="element-1069">STATUS</th>
                <th className="px-4 py-3 font-semibold" data-id="element-1070">LOGIN TERAKHIR</th>
                <th className="px-4 py-3 font-semibold text-center" data-id="element-1071">AKSI</th>
              </tr>
            </thead>
            <tbody data-id="element-1072">
              {filteredUsers.length > 0 ? filteredUsers.map((user, index) => <tr key={user.id} className="border-b border-[#1E3A5F]/50 hover:bg-[#1A2332] transition-colors" data-id="element-1073">
                    <td className="px-4 py-3 text-center text-[#94A3B8] font-mono text-xs" data-id="element-1074">
                      U{(index + 1).toString().padStart(3, '0')}
                    </td>
                    <td className="px-4 py-3" data-id="element-1075">
                      <div className="font-semibold text-[#E2E8F0] text-sm" data-id="element-1076">
                        {user.name}
                      </div>
                      <div className="text-xs text-[#00D4FF] mt-0.5" data-id="element-1077">
                        {user.email}
                      </div>
                    </td>
                    <td className="px-4 py-3 text-[#94A3B8] text-sm" data-id="element-1078">
                      {user.username}
                    </td>
                    <td className="px-4 py-3 text-[#94A3B8] text-sm" data-id="element-1079">
                      {user.unit}
                    </td>
                    <td className="px-4 py-3" data-id="element-1080">
                      <span className="bg-[#00D4FF]/10 text-[#00D4FF] border border-[#00D4FF]/20 text-xs font-semibold px-2 py-0.5 rounded" data-id="element-1081">
                        {user.role}
                      </span>
                    </td>
                    <td className="px-4 py-3 text-center" data-id="element-1082">
                      {user.isActive ? <span className="bg-[#00FF88]/10 text-[#00FF88] border border-[#00FF88]/20 text-xs font-bold px-2 py-0.5 rounded uppercase tracking-wider glow-green" data-id="element-1083">
                          AKTIF
                        </span> : <span className="bg-[#FF3B3B]/10 text-[#FF3B3B] border border-[#FF3B3B]/20 text-xs font-bold px-2 py-0.5 rounded uppercase tracking-wider" data-id="element-1084">
                          NONAKTIF
                        </span>}
                    </td>
                    <td className="px-4 py-3 text-[#64748B] font-mono text-xs" data-id="element-1085">
                      {new Date(user.lastLoginAt).toLocaleString('id-ID')}
                    </td>
                    <td className="px-4 py-3" data-id="element-1086">
                      <div className="flex items-center justify-center space-x-2" data-id="element-1087">
                        <button onClick={handleEditUser} className="p-1.5 text-[#00D4FF]/60 hover:text-[#00D4FF] hover:bg-[#00D4FF]/10 rounded transition-colors" title="Edit" data-id="element-1088">
                          <PencilIcon className="w-4 h-4" data-id="element-1089" />
                        </button>
                        <button onClick={handleResetPassword} className="p-1.5 text-[#FFB800]/60 hover:text-[#FFB800] hover:bg-[#FFB800]/10 rounded transition-colors" title="Reset Password" data-id="element-1090">
                          <KeyIcon className="w-4 h-4" data-id="element-1091" />
                        </button>
                        <button onClick={() => handleToggleActive(user.name, user.isActive)} className={`p-1.5 rounded transition-colors ${user.isActive ? 'text-[#FF3B3B]/60 hover:text-[#FF3B3B] hover:bg-[#FF3B3B]/10' : 'text-[#00FF88]/60 hover:text-[#00FF88] hover:bg-[#00FF88]/10'}`} title={user.isActive ? 'Nonaktifkan' : 'Aktifkan'} data-id="element-1092">
                          <PowerIcon className="w-4 h-4" data-id="element-1093" />
                        </button>
                      </div>
                    </td>
                  </tr>) : <tr data-id="element-1094">
                  <td colSpan={8} className="px-4 py-8 text-center text-[#94A3B8] text-sm" data-id="element-1095">
                    Tidak ada user yang sesuai dengan filter.
                  </td>
                </tr>}
            </tbody>
          </table>
        </div>
      </div>
    </div>;
}